module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARgAAAEYAQMAAAC9QHvPAAAABlBMVEX///8AAABVwtN+AAABPElEQVRoge2VS3IDUQgDdf9LK3GQAMdTvoDAi/nQb9MljYGb78Oa35vXLeZhNtlMWfLSp/4oaJ/N6I01vq7E2hxjY1yVO+bDoTp5zDujPGE2pfShp4lMDR5+2mQzM1bY9w+TyNBfpelevV4Kc5m5asmpnZuYzViifLqWHbpsps3tO1TiHLdshv1K721xOcxlqJSh1TljW2syA9dNHyYlT8QxEy8/2avtRjOsnK3SdSudvWTGgWpZOtKnw5mJFNuePVpjMlPxAt1BmsfSHM0oXLXbK67U5TJ+pmXC8yExkVmV02NX8hhgxWj+4TgWmc74m0QXEH2Czlsys3ShO9iXdSqUsSx5RHezf+GMDbIoY/5gHfNWv3WEK2fHCCh8xQ/HcLqmLtpde0xm2t7/vZfZjNtGdBvLpNhw5ubb/ABSUC/AjyR9yAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/snwb.png
// module id = +zid
// module chunks = 49